/* Etiquetas multiidoma en castellano. */
export default {
  "cancelConditionsViewer.dialog.title": "Política de cancelación",
  "cancelConditionsViewer.title": "Política de cancelación",
};
